import React from "react";

import { Heading, Appear, Slide } from "spectacle";
import { CustomHeading } from "../../../custom-style";

export default () => {
  return (
    <Slide>
      <CustomHeading fit>Conceptos Básicos</CustomHeading>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/02-core-concepts/01-title.js